module.exports = __webpack_public_path__ + "static/media/SchoolCosDeliveryTeacher.9f0bb898.webp";